<template>
  <div class="checkoutrightbody">
    <div class="shoppingcarlistwrap">
      <transition>
        <div class="scrollHint" v-if="scrollOff">Scroll for more items ↓</div>
      </transition>
      <div :class="orders_query?'shoppingcarlist borderbottom':'shoppingcarlist'">
        <div
          class="row align-items-center shoppingcarlistsitem"
          v-for="(item,index) in line_items"
          :key="index"
        >
          <div class="smallphotowarp">
            <span>{{item.qty}}</span>
            <div class="smallphoto">
              <!-- 要是商品被删了会导致thank you页面的product属性也不存在 -->
              <img
                v-if="item.feature_image"
                :src="item.feature_image.thumbnail?item.feature_image.thumbnail:defaultImage"
                alt
                class="lazyload"
                @error.once="imageFailure"
              />
              <img v-else :src="defaultImage" alt />
            </div>
          </div>
          <div class="col productmes">
            <div>{{item.order_item_name}}</div>
            <div class="variant" v-if="item.attrs.constructor==Object">
                <template v-for="(subitem,subindex) in item.attrs" >
                  <span  v-if="subitem!='Default Title'"  :key="subindex">{{subitem}}</span>
                </template>
            </div>
          </div>
          <div class="price"><v-currencysymbol></v-currencysymbol>{{(item.line_subtotal-0).toFixed(2)}}</div>
        </div>
      </div>
    </div>
    <v-discountcode v-if="this.orders_query" :getcoupons="coupons" @newcartmes="newcartmes"></v-discountcode>
    <div class="computed">
      <div class="computedlist">
        <div>
          <span>{{$t('shopping.subtotal')}}</span>
          <span><v-currencysymbol></v-currencysymbol>{{(order_subtotal-0).toFixed(2)}}</span>
        </div>
        <div v-if="coupons.length!=0">
          <span>
            {{$t('shopping.discount')}}
            <i
              class="iconfont icon-biaoqian"
            >&nbsp;{{coupons[0].auto_coupon?coupons[0].description:coupons[0].code}}</i>
          </span>
          <span>-<v-currencysymbol></v-currencysymbol>{{(discount_cart-0).toFixed(2)}}</span>
        </div>
        <div
          v-if="this.$store.state.shipping_insurance_price!==0&&(this.$store.state.shipping_insurance_price||order_insurance_price)"
        >
          <span>{{$t('shopping.shipping_insurance')}}</span>
          <span
            v-if="this.$store.state.shipping_insurance_price"
          ><v-currencysymbol></v-currencysymbol>{{(this.$store.state.shipping_insurance_price-0).toFixed(2)}}</span>
          <span v-else><v-currencysymbol></v-currencysymbol>{{(this.order_insurance_price-0).toFixed(2)}}</span>
        </div>
        <div>
          <span>{{$t('shopping.shipping')}}</span>
          <span v-if="!cart.ID">
            <span
              a="1"
              v-if="this.$store.state.order_shipping===''"
            >{{cart.shipping.chosen_method? order_shipping!='0'? getSymbolFromCurrency($store.state.checkoutcurrency)+(order_shipping-0).toFixed(2):$t('shopping.free'): $t('shopping.calculated_at_next_step')}}</span>
            <span
              v-else
              a="2"
            >{{this.$store.state.order_shipping?getSymbolFromCurrency($store.state.checkoutcurrency)+(this.$store.state.order_shipping-0).toFixed(2):$t('shopping.free')}}</span>
          </span>
          <span v-else>{{order_shipping=='0.00'? $t('shopping.free'): getSymbolFromCurrency($store.state.checkoutcurrency) + order_shipping }}</span>
        </div>
      </div>
      <div class="computetotal">
        <span>{{$t('shopping.total')}}</span>
        <p>
          <i>{{this.$store.state.checkoutcurrency}}</i>
          <span><v-currencysymbol></v-currencysymbol>{{computedTotal}}</span>
          <!-- <span>${{this.$store.state.order_shipping||this.$store.state.shipping_insurance_price?(order_total-order_shipping-order_insurance_price+this.$store.state.order_shipping-0+this.$store.state.shipping_insurance_price-0).toFixed(2):(order_total-0).toFixed(2)}}</span> -->
        </p>
      </div>
      <div class="order-tips" v-if="order_tip">
        <img v-if="order_tip_img" :src="order_tip_img" />
      </div>
    </div>
  </div>
</template>
<script>
import vDiscountcode from "./dicountcode";
import defaultImage from "../../../../../public/images/no-image.gif";
import getSymbolFromCurrency from "currency-symbol-map";
export default {
  props: ["orders_query", "cart", "order_tip", "order_tip_img"],
  data() {
    return {
      defaultImage,
      line_items: [], //购物车商品
      order_subtotal: "", //折扣前总价
      order_shipping: "", //最终邮费
      coupons: [], //优惠券列表
      order_total: "", //最终总价
      discount_cart: 0, //优惠了价格
      scrollOff: false,
      order_insurance_price: 0, //最终运费险价格
      getSymbolFromCurrency:""
    };
  },
  computed:{
    computedTotal(){
      let cartTotal=this.order_total;
      if(this.$store.state.order_shipping!==''&&this.cart.shipping&&this.cart.shipping.chosen_method){
        cartTotal=cartTotal-this.order_shipping+this.$store.state.order_shipping;
      }else if(this.$store.state.order_shipping!==''){
        cartTotal+=this.$store.state.order_shipping;
      }
      if(this.$store.state.shipping_insurance_price!==''&&this.cart.shipping_insurance){
        cartTotal=cartTotal-this.order_insurance_price+this.$store.state.shipping_insurance_price;
      }else if(this.$store.state.shipping_insurance_price!==''){
        cartTotal=cartTotal+this.$store.state.shipping_insurance_price
      }
      return (cartTotal-0).toFixed(2);
    }
  },
  methods: {
    imageFailure(e) {
      e.target.src = defaultImage;
    },
    newcartmes(newcartmes) {
      this.coupons = Object.values(newcartmes.coupons);
      this.order_total = newcartmes.cart_total;
      this.order_shipping = newcartmes.shipping_total;
      this.discount_cart = newcartmes.discount_cart;
    }
  },
  beforeMount(){
     this.getSymbolFromCurrency=getSymbolFromCurrency;
  },
  mounted() {
    console.log("order_tip", this.order_tip);
    console.log("order_tip_img", this.order_tip_img == null, "111");

    if (this.cart.ID) {
      // thank页面的字段
      this.line_items = this.cart.line_items;
      this.order_shipping = this.cart.order_shipping;
      this.order_total = this.cart.order_total;
      if (this.cart.fees[0]) {
        this.order_insurance_price = this.cart.fees[0].line_total;
      }
      // this.line_items.forEach(item => {
      //   item.product.image = item.product.medium
      //     ? item.product.medium
      //     : defaultImage;
      // });
      // 折扣前总价order_subtotal在thank页面是总价减去邮费加上折扣的价格
      this.order_subtotal = this.cart.fees[0]
        ? this.cart.order_total -
          this.cart.order_shipping -
          this.cart.fees[0].fee_amount
        : this.cart.order_total - this.cart.order_shipping;
      //thank页面的百分比优惠券已经是计算后的
      this.cart.coupons.forEach(item => {
        this.discount_cart += item.discount_amount - 0;
        this.order_subtotal += item.discount_amount - 0;
        //购物车页面和thank页面的字段不一样
        this.coupons.push({
          auto_coupon: item.auto_coupon,
          code: item.order_item_name,
          description: item.content
        });
      });
    } else {
      // 购物车页面的字段
      for (let item in this.cart.cart) {
        let attrs = {};
        if (this.cart.cart[item].variant) {
          this.cart.cart[item].variant.attrs.forEach(item => {
            attrs[item.name] = item.value;
          });
        } else {
          attrs = [];
        }
        this.line_items.push({
          order_item_name: this.cart.cart[item].product.post_title,
          line_subtotal: this.cart.cart[item].line_subtotal,
          qty: this.cart.cart[item].quantity,
          attrs,
          feature_image: this.cart.cart[item].variant
            ? this.cart.cart[item].variant.feature_image
              ? this.cart.cart[item].variant.feature_image
              : this.cart.cart[item].product.feature_image
            : this.cart.cart[item].product.feature_image
        });
      }
      if (this.cart.fees["shipping-insurance"]) {
        this.order_insurance_price = this.cart.fees["shipping-insurance"].total;
      }
      console.log("order_insurance_price", this.order_insurance_price);
      this.order_subtotal = this.cart.cart_subtotal;
      this.order_shipping = this.cart.shipping_total;
      this.order_total = this.cart.cart_total;
      this.discount_cart = this.cart.discount_cart;
      //购物车获取到的优惠券信息是对象的格式
      this.coupons = Object.values(this.cart.coupons);
    }
    console.log("line_items", this.line_items);

    console.log("cart", this.cart);

    window.setTimeout(() => {
      console.log(this.$(window).width());
      console.log(this.$(window).height());
      if (
        this.$(window).width() > 991 &&
        this.$(".shoppingcarlist")[1].clientHeight / this.$(window).height() >
          0.53
      ) {
        this.scrollOff = true;
        this.$(".shoppingcarlist").scroll(() => {
          console.log(111);
          this.scrollOff = false;
          this.$(".shoppingcarlist").unbind();
        });
      }
    }, 1000);
  },
  components: {
    vDiscountcode
  },
  watch: {
    async "$store.state.update_cart"() {
      if (this.$store.state.update_cart) {
        try {
          let res = await this.$axios.get("api/store/cart");
          console.log("$store.state.update_cart", res);
          this.order_subtotal = res.data.cart_subtotal;
          this.order_shipping = res.data.shipping_total;
          this.order_total = res.data.cart_total;
          this.discount_cart = res.data.discount_cart;
          //购物车获取到的优惠券信息是对象的格式
          this.coupons = Object.values(res.data.coupons);
        } catch (error) {
          console.log(error.response);
        }
      }
    },
    "$store.state.news_cart"() {
      this.coupons = Object.values(this.$store.state.news_cart.coupons);
      this.order_total = this.$store.state.news_cart.cart_total;
      this.order_shipping = this.$store.state.news_cart.shipping_total;
      this.discount_cart = this.$store.state.news_cart.discount_cart;
      console.log(this.$store.state.news_cart);
    }
  }
};
</script>
<style scoped lang='scss'>
.checkoutrightbody {
  color: black;

  .borderbottom {
    border-bottom: 1px solid #e5e5e5;
  }

  .shoppingcarlistwrap {
    position: relative;
    .shoppingcarlist {
      padding-top: 10px;
      .shoppingcarlistsitem {
        padding: 0 15px;
        margin-bottom: 14px;
        font-size: 14px;
        .smallphotowarp {
          position: relative;
          span {
            height: 21px;
            line-height: 21px;
            opacity: 0.6;
            font-size: 12px;
            position: absolute;
            padding: 0 7px;
            top: -8px;
            right: -5px;
            border-radius: 15px;
            background-color: black;
            color: white;
            text-align: center;
          }
          .smallphoto {
            width: 64px;
            height: 64px;
            border-radius: 10px;
            overflow: hidden;
            border: 1px solid #e5e5e5;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .productmes {
          & > div:first-child {
            font-size: 16px;
            color: #323232;
          }
          .variant {
            font-size: 12px;
            color: #717171;
            span:not(:last-child)::after {
              content: " / ";
            }
          }
        }
      }
    }
    .scrollHint {
      position: absolute;
      z-index: 2;
      bottom: 20px;
      left: 50%;
      color: #fafafa;
      border-radius: 30px;
      font-size: 12px;
      transform: translateX(-50%);
      padding: 7.2px 14.4px;
      background-color: rgba(50, 50, 50, 0.85);
      &:hover + .shoppingcarlist {
        overflow-y: auto !important;
      }
    }
  }

  .computed {
    border-top: 1px solid #e5e5e5;

    .computedlist {
      padding-top: 21px;
      padding-bottom: 21px;
      border-bottom: 1px solid #e5e5e5;

      div {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #535353;
        span:last-child {
          color: #323232;
          font-weight: 600;
          white-space: nowrap;
        }
        span {
          word-break: break-word;
          i {
            margin-left: 5px;
            font-style: normal;
          }
        }
      }

      & > div:not(:first-child) {
        margin-top: 10.5px;
      }
    }
    .order-tips {
      img {
        max-width: 100%;
        height: auto;
        display: block;
        margin: auto;
      }
    }

    .computetotal {
      padding-top: 16px;
      padding-bottom: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      p {
        margin-bottom: 0;
        i {
          font-size: 12px;
          font-style: normal;
          vertical-align: middle;
          margin-right: 6px;
          color: #717171;
        }

        span {
          font-size: 24px;
          font-weight: 600;
          color: #323232;
        }
      }
    }
  }
}

.v-enter-active,
.v-leave-active {
  transition: all 0.2s ease;
}
.v-enter {
  bottom: -30px !important;
}
.v-leave-to {
  bottom: 60px !important;
  opacity: 0 !important;
}

@media screen and( min-width: 992px) {
  .checkoutrightbody {
    .shoppingcarlistwrap {
      overflow: hidden;
      .shoppingcarlist {
        max-height: 55vh !important;
        overflow: hidden !important;
        &:hover {
          overflow-y: auto !important;
        }
      }
    }
  }
}
@media screen and( max-width: 992px) {
  .checkoutrightbody {
    .shoppingcarlistwrap {
      .scrollHint {
        display: none;
      }
      .shoppingcarlist {
        .shoppingcarlistsitem {
          .productmes {
            & > div:first-child {
              font-size: 14px !important;
              color: #323232;
            }
          }
        }
      }
    }
    .computed {
      .order-tips {
        margin-bottom: 20px !important;
      }
    }
  }
}
</style>